import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import door from "../assets/door.webp";
import uni from "../assets/services/University selection.webp";
import test from "../assets/services/Test Preparation.webp";
import appli from "../assets/services/Application Assistance.webp";
import visa from "../assets/services/Visa Guidance.webp";
import fin from "../assets/services/Financial Assistance.webp";
import pre from "../assets/services/Pre-Departure Assistance.png";
import acco from "../assets/services/Accommodation Assistance.webp";
import post from "../assets/services/Post-Arrival Assistance.png";

/* ================= SERVICES DATA ================= */
const services = [
  {
    title: "Door-to-Door Counselling",
    description:
      "Personalized counselling at your doorstep for study, work, and migration abroad.",
    image:door,
  },
  {
    title: "University Selection",
    description:
      "Choosing the right university based on your profile, budget, and career goals.",
    image:uni,
  },
  {
    title: "Test Preparation",
    description:
      "Expert coaching for IELTS, TOEFL, PTE and other entrance exams.",
    image:test,
  },
  {
    title: "Application Assistance",
    description:
      "End-to-end application handling with accuracy and timely submissions.",
    image:appli,
  },
  {
    title: "Financial Assistance",
    description:
      "Guidance on education loans, scholarships, and financial planning.",
    image:fin,
  },
  {
    title: "Visa Guidance",
    description:
      "Expert visa documentation, interview preparation, and filing support.",
    image:visa,
  },
  {
    title: "Pre-Departure Assistance",
    description:
      "Complete briefing before departure including travel and compliance.",
    image:pre,
  },
  {
    title: "Accommodation Assistance",
    description:
      "Help in finding safe and affordable accommodation abroad.",
    image:acco,
  },
  {
    title: "Post-Arrival Assistance",
    description:
      "Support after arrival including pickup, SIM, banking, and settling in.",
    image:post,
  },
];

export default function ServicesSection() {
  return (
    <section className="py-28 bg-gradient-to-b from-white via-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* HEADER */}
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Our <span className="text-[#2596BE]">Services</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            From counselling to post-arrival support — we guide you at every step
            of your overseas journey.
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-14 md:gap-16 lg:gap-20">

          {services.map((service, idx) => {
  const slug = service.title.toLowerCase().replace(/\s+/g, "-");

  return (
    <Link key={idx} to={`/services/${slug}`} className="block">
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative h-[380px] perspective-[1400px] cursor-pointer"
        whileHover="hover"
      >

        {/* FLIP CARD */}
        <motion.div
          variants={{
            hover: { rotateY: 180 },
          }}
          initial={{ rotateY: 0 }}
          transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="relative w-full h-full rounded-[32px] [transform-style:preserve-3d]"
        >

          {/* FRONT */}
          <div className="absolute inset-0 rounded-[32px] bg-white overflow-hidden shadow-[0_30px_80px_-30px_rgba(0,0,0,0.3)] [backface-visibility:hidden]">
            <img
              src={service.image}
              alt={service.title}
              className="absolute inset-0 w-full h-full object-cover"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-xl font-semibold text-white">
                {service.title}
              </h3>
            </div>
          </div>

          {/* BACK */}
          <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#2596BE] to-[#1E4F91] text-white p-10 flex flex-col justify-center shadow-[0_40px_90px_-30px_rgba(37,150,190,0.6)] [transform:rotateY(180deg)] [backface-visibility:hidden]">
            <h3 className="text-xl font-semibold mb-4">
              {service.title}
            </h3>

            <p className="text-sm leading-relaxed text-blue-100">
              {service.description}
            </p>
          </div>

        </motion.div>
      </motion.div>

    </Link>
  );
})}

        </div>
      </div>
    </section>
  );
}
